import { useCallback, useEffect, useLayoutEffect, useState } from 'react';

// got from here https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
export function useVHAdjustment() {
  const [newVH, setNewVH] = useState(0);

  useEffect(() => {
    if (newVH > 0) {
      document.documentElement.style.setProperty('--vh', `${newVH}px`);
    }
  }, [newVH]);

  const checkContainerWidth = useCallback(() => {
    const vh = window.innerHeight * 0.01;
    if (vh !== newVH) {
      setNewVH(vh);
    }
  }, [newVH]);

  useLayoutEffect(() => {
    checkContainerWidth();
    window.addEventListener('resize', checkContainerWidth);
    return () => window.removeEventListener('resize', checkContainerWidth);
  }, [checkContainerWidth]);
}
